import api from './api';

const userService = {
  // Alle Benutzer abrufen
  getUsers: async (params = {}) => {
    const response = await api.get('/users', { params });
    return response.data;
  },

  // Einzelnen Benutzer abrufen
  getUser: async (userId) => {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  },

  // Verfügbare Berechtigungen abrufen
  getPermissions: async () => {
    const response = await api.get('/users/permissions');
    return response.data;
  },

  // Neuen Benutzer erstellen
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  // Benutzer aktualisieren
  updateUser: async (userId, userData) => {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  },

  // Passwort zurücksetzen
  resetPassword: async (userId, newPassword) => {
    const response = await api.post(`/users/${userId}/reset-password`, {
      new_password: newPassword
    });
    return response.data;
  },

  // Benutzer löschen
  deleteUser: async (userId) => {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  },

  // Standard-Berechtigungen für Rolle anwenden
  applyRolePermissions: async (userId) => {
    const response = await api.post(`/users/${userId}/apply-role-permissions`);
    return response.data;
  }
};

export default userService;
